import React from 'react';
import { parseISO } from 'date-fns';
import { formatDate } from '../../../helpers/dates';
import type { ConfirmDialogOptions } from './ConfirmDialog';

const cancelBookingDialog = (owner: React.ReactNode, deskLabel: string, date: string, onConfirm: () => void): ConfirmDialogOptions => ({
  title: 'Cancel booking?',
  message: (
    <>
      Cancel {owner} booking of <strong>{deskLabel}</strong> on <strong>{formatDate(parseISO(date), 'EEE dd.MM.')}</strong>?
    </>
  ),
  confirmLabel: 'Cancel booking',
  cancelLabel: 'Keep',
  danger: true,
  onConfirm,
});

export default cancelBookingDialog;
